import { useTranslation } from "react-i18next";
import { MoonStar } from "lucide-react";
import { Button, Dialog, Typography } from "@akuna/ui";
import type { PanelPet } from "../panel/panelModel";
import { OvernightToggleSection } from "./OvernightToggleSection";

export interface OvernightDialogProps {
  pet: PanelPet;
  isoDate: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Casca fina para o botão de lua do card — o conteúdo é o mesmo dos modais. */
export function OvernightDialog({ pet, isoDate, open, onOpenChange }: OvernightDialogProps) {
  const { t } = useTranslation("daycareHotel");

  return (
    <Dialog
      closeLabel={t("panel.close")}
      mode="adaptive"
      open={open}
      onOpenChange={onOpenChange}
      icon={
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-purple-50 text-akuna-purple">
          <MoonStar aria-hidden="true" size={22} />
        </span>
      }
      title={t("panel.overnightTitle", { name: pet.petName })}
      header={
        <Typography asChild variant="caption" className="text-muted-foreground">
          <span>{t("panel.overnightSubtitle")}</span>
        </Typography>
      }
      footer={<Button variant="outline" onClick={() => onOpenChange(false)}>{t("panel.close")}</Button>}
    >
      <OvernightToggleSection pet={pet} isoDate={isoDate} onAdded={() => onOpenChange(false)} />
    </Dialog>
  );
}
